
import React from 'react';
import { Card } from '@/components/ui/card';
import MapboxMap from '@/components/MapboxMap';
import { Terrace } from '@/types/terrace';
import { ExternalLink } from 'lucide-react';

interface TerraceMapSectionProps {
  terrace: Terrace;
  compact?: boolean;
}

const TerraceMapSection = ({ terrace, compact = false }: TerraceMapSectionProps) => {
  // Create a single terrace array for the map
  const terraceArray = [terrace];

  const handleMapClick = () => {
    if (terrace.original_maps_url) {
      window.open(terrace.original_maps_url, '_blank');
    } else {
      // Fallback to Google Maps with coordinates
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${terrace.lat},${terrace.lng}`;
      window.open(googleMapsUrl, '_blank');
    }
  };

  const cardHeight = compact ? "h-[200px]" : "h-[400px]";
  const titleSize = compact ? "text-lg" : "text-xl";
  const containerClass = compact ? "" : "mt-8";

  return (
    <div className={containerClass}>
      <h2 className={`${titleSize} font-bold mb-4 text-sunset-dark`}>Location</h2>
      <Card className={`${cardHeight} overflow-hidden border border-peach-orange/20 shadow-sm`}>
        <div className="w-full h-full">
          <MapboxMap 
            terraces={terraceArray}
            userLocation={null}
            onMapClick={handleMapClick}
            interactive={false}
          />
        </div>
      </Card>
      <div className="mt-2 text-sm text-sunset-medium">
        <button 
          onClick={handleMapClick}
          className="text-left hover:text-peach-orange transition-colors cursor-pointer underline decoration-dotted hover:decoration-solid flex items-center gap-1"
        >
          <span>{compact ? terrace.address.split(',')[0] : terrace.address}</span>
          <ExternalLink className="h-3 w-3 flex-shrink-0" />
        </button>
      </div>
    </div>
  );
};

export default TerraceMapSection;
